export default "__VITE_ASSET__DsDxJqn6__"